import { useEffectOnce } from '@dx-system/react-use'

import { useForegroundPushNotification } from 'hooks/pushNotification/useForegroundPushNotification'
import { useCallback, useEffect } from 'react'

export const useApp = () => {
  useForegroundPushNotification()

  // ブラウザ判定
  const isFirefox = navigator.userAgent.toLowerCase().includes('firefox')

  useEffectOnce(() => {
    const container = document.getElementById('root')
    if (!container) throw new Error('root element not found')

    // Firefoxの場合、クラスを追加
    isFirefox && container.parentElement?.classList.add('is-firefox')
  })

  // iOS判定
  const isIOS = useCallback((): boolean => {
    if (typeof window === 'undefined') return false

    const ua = window.navigator.userAgent

    const isIOS =
      /iPad|iPhone|iPod/.test(ua) ||
      // iPadOS 13+ 対応（Macintosh と表示される）
      (ua.includes('Macintosh') && 'ontouchend' in document)

    return isIOS
  }, [])

  // iOSデバイスの場合、is-iosクラスを付与する
  useEffect(() => {
    const isIOSDevice = isIOS()
    if (isIOSDevice) {
      document.documentElement.classList.add('is-ios')
    }

    return () => {
      if (isIOSDevice) {
        document.documentElement.classList.remove('is-ios')
      }
    }
  }, [isIOS])
}
